import { FilterSheetMenuItem } from './components/FilterSheetMenuItem'
import { SheetSelectRow } from './SheetSelectRow'

import styles from './FiltersMobileSheet.module.scss'

type FilterOption = {
  id: string
  label: string
}

type GatewayListMobileOptionFilterSectionProps = {
  rowLabel: string
  displayValue: string
  menuOpen: boolean
  onMenuOpenChange: (open: boolean) => void
  options: FilterOption[]
  selectedId: string
  onSelect: (id: string) => void
  showDivider?: boolean
  menuItemTestIdPrefix?: string
}

export function GatewayListMobileOptionFilterSection({
  rowLabel,
  displayValue,
  menuOpen,
  onMenuOpenChange,
  options,
  selectedId,
  onSelect,
  showDivider = true,
  menuItemTestIdPrefix = 'gateway-list-filter-sheet-option',
}: GatewayListMobileOptionFilterSectionProps) {
  return (
    <>
      {showDivider ? <div className={styles.rowDivider} /> : null}
      <SheetSelectRow
        rowLabel={rowLabel}
        displayValue={displayValue}
        menuOpen={menuOpen}
        onMenuOpenChange={onMenuOpenChange}
      >
        <div className={styles.menuItems}>
          {options.map((option) => (
            <FilterSheetMenuItem
              key={option.id}
              label={option.label}
              isSelected={selectedId === option.id}
              onSelect={() => onSelect(option.id)}
              testId={`${menuItemTestIdPrefix}-${option.id}`}
            />
          ))}
        </div>
      </SheetSelectRow>
    </>
  )
}
